import { init } from '@paralleldrive/cuid2';

export const createQueryId = init({ length: 4 });

// This function generates a random query string to refresh the SEO metadata on social platforms when the link is shared.
export const createPageQueryRandomValue = () => `v=${createQueryId()}`;
